import type { ThemeOptions } from '@mui/material/styles';

export const light: ThemeOptions = {
  palette: {
    mode: 'light',
    success: { main: '#34A853' },
    error: { main: '#D93025' },
    warning: { main: '#E2B534' },
    info: { main: '#2D8CBA' },
    background: { default: '#fafaf9', paper: '#fafaf9' },
    primary: {
      main: '#043F7A',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#2CAEC9',
      contrastText: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'Poppins',
    fontSize: 16,
    h2: {
      fontSize: '2.4rem',
      fontWeight: 500,
      color: '#043F7A',
    },
    h3: {
      fontSize: '2rem',
      fontWeight: 500,
      color: '#043F7A',
    },
    body1: {
      fontSize: '1.2rem',
      fontWeight: 400,
    },
    body2: {
      fontSize: '1.2rem',
      fontWeight: 500,
    },
  },
  components: {
    MuiScopedCssBaseline: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.background.default,
        }),
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          minHeight: '56px',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          padding: '24px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          height: '100%',
          fontSize: '1.25rem',
          fontWeight: '500',
          borderRadius: '10px',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          textAlign: 'left',
        },
      },
    },
  },
};
